import React from 'react';
import { Card, CloseButton, Col, Row } from 'react-bootstrap';
import { getStudentLocation } from '../../helpers/getStudentLocation';
import { SALES_ORIGIN_TEXT } from '../../constants';
import './salesMetrics.css';

const OriginItem = ({ origin }) => {
  const location = getStudentLocation(origin);

  if (!origin.hasStudent) {
    return <li className="text-muted">{SALES_ORIGIN_TEXT.UNLINKED_STUDENT}</li>;
  }

  return (
    <li>
      {location.region || SALES_ORIGIN_TEXT.UNDEFINED_LOCATION}, {location.country || SALES_ORIGIN_TEXT.UNDEFINED_LOCATION}
      {location.isGuessed && (
        <span className="text-muted" title={SALES_ORIGIN_TEXT.GUESSED_HINT}> ≈</span>
      )}
    </li>
  );
};

const renderOriginItem = (origin, index) => <OriginItem key={index} origin={origin} />;

const OriginColumn = ({ title, titleClassName, origins }) => (
  <Col md>
    <p className={titleClassName}>
      <strong>{title}:</strong> {origins.length} {SALES_ORIGIN_TEXT.SALES_LABEL}
    </p>
    {origins.length ? (
      <ul className="mb-0">{origins.map(renderOriginItem)}</ul>
    ) : (
      <p className="text-muted mb-0">{SALES_ORIGIN_TEXT.NO_SALES_MESSAGE}</p>
    )}
  </Col>
);

const SalesOriginBreakdown = ({ point, currentLabel, previousLabel, showPreviousLine, onClose }) => (
  <Card className="mt-3">
    <Card.Header className="d-flex justify-content-between align-items-center">
      <strong>{SALES_ORIGIN_TEXT.TITLE_PREFIX} {point.day}</strong>
      <CloseButton onClick={onClose} />
    </Card.Header>
    <Card.Body>
      <Row>
        <OriginColumn title={currentLabel} titleClassName="mb-2 salesCurrentPeriod" origins={point.currentOrigins} />
        {showPreviousLine && (
          <OriginColumn title={previousLabel} titleClassName="mb-2 salesPreviousPeriod" origins={point.previousOrigins} />
        )}
      </Row>
    </Card.Body>
  </Card>
);

export default SalesOriginBreakdown;
